import { ReactElement, ReactNode } from 'react'

export class Filter {
    name: string
    _id: string
    isDefault: boolean
    isApply: boolean
    isOriginalFilter: boolean
    categories: {
        project: {
            projectTitle: string
            status: {
                activity: string[]
            }
            type: Record<string, string[]>
            referenceUser: string[]
            departement: string[]
            priority: string[]
            favourite: boolean
            overdue: boolean
        }
        storeSpecs: {
            macroregion: string[]
            region: string[]
            country: string[]
            zone: string[]
            storeLocation: string[]
            city: string[]
            segment: string[]
            host: string[]
            storeHost: string[]
            businessModel: string[]
            banner: string[]
            store: string[]
        }
        timeFrame: {
            from: number
            to: number
            reportTime: { _id: string; code: string; value: string }
        }
        photoSpecs: {
            macroAreas: string[]
            status: string[]
            tags: string[]
            specialCollections: string[]
        }
    }
    constructor(id: string) {
        this._id = id
        this.name = ''
        this.isDefault = false
        this.isApply = false
        this.isOriginalFilter = false
        this.categories = {
            project: {
                projectTitle: '',
                status: {
                    activity: [],
                },
                type: {},
                referenceUser: [],
                departement: [],
                priority: [],
                favourite: false,
                overdue: false,
            },
            storeSpecs: {
                macroregion: [],
                region: [],
                country: [],
                zone: [],
                storeLocation: [],
                city: [],
                segment: [],
                host: [],
                storeHost: [],
                businessModel: [],
                banner: [],
                store: [],
            },
            timeFrame: {
                from: null,
                to: null,
                reportTime: null,
            },
            photoSpecs: {
                macroAreas: [],
                status: [],
                tags: [],
                specialCollections: [],
            },
        }
    }
}

export interface ItemList {
    value: string
    label: string
}

export type FilterSubcategoryItemProps = {
    label: string
    type: TypeOfSubcategory
    customContent?: ReactNode
    listOptions?: ItemList[]
    filterPath: string
    filterValue?: any
    setFilterValue?: (val: any) => void
    setListOptions?: (val: string) => void
    optionLabel?: string
    optionValue?: string
    translateLabel?: boolean
    showBadge?: boolean
    customBadge?: ReactElement
    onReset?: () => void
    disabled?: boolean
    minDigit?: number
    isLoading?: boolean
    isCollapsed?: boolean
    keepOpen?: boolean
}

/**
 * STATUS: List of checkboxes grouped by status (with colored dot)
 * MULTISELECT: List of checkboxes
 * AUTOCOMPLETE_MULTISELECT: Multiselect with autocomplete
 * SWITCH: Not collapsible, one switch on the right side
 * CUSTOM: Custom content (must specify customContent prop)
 */
export type TypeOfSubcategory =
    | 'STATUS'
    | 'MULTISELECT'
    | 'SWITCH'
    | 'AUTOCOMPLETE_MULTISELECT'
    | 'CUSTOM'

export type FilterCategoryType = 'PROJECTS' | 'STORE_SPECS' | 'TIME_FRAME' | 'PHOTO_SPECS'

export type FiltersCategoryMenuItem = {
    category?: string
    isActive?: boolean
    label: string
    showBadge?: boolean
    showSavingFilter?: boolean
    onClick: () => void
    filterList?: FilterSubcategoryItemProps[]
}

export type FilterCategory = {
    category: string
    isActive: boolean
    label: string
    showBadge: boolean
    onClick: () => void
    filterList: FilterSubcategoryItemProps[]
}

export type StepPage = 'SELECT_CATEGORY' | 'CATEGORY_SELECTED' | 'SAVING_FILTER' | null

export const ID_ORIGINAL_FILTER_FE = 'original_filter'
export const ID_ORIGINAL_ALBUM_FILTER_FE = 'albums_original_filter'
